import { createApi } from '@reduxjs/toolkit/query/react'
import { ATTACH_DOCUMENT, PUBLISH_DOCUMENT, UPDATE_APPOINTMENT_COUNT } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const attachmentApi = createApi({
    reducerPath: 'attachmentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client",
    }),
    tagTypes: ["ReportResourceDetail"],
    endpoints: (builder) => ({

        // attach document
        attachDocument: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "PUT",
                url: `${ATTACH_DOCUMENT}/${clientId}`,
                data
            })
        }),

        // attach document
        publishDocument: builder.mutation({
            query: ({ clientId, resourceId }) => ({
                method: "PUT",
                url: `${PUBLISH_DOCUMENT}/${clientId}/${resourceId}`
            })
        }),

        // update free appointment count
        updateAppointmentCount: builder.mutation({
            query: ({ clientId, value }) => ({
                method: "PUT",
                url: `${UPDATE_APPOINTMENT_COUNT}/${clientId}/${value}`
            })
        }),

        // get report resources and attachments
        getReportResourceDetail: builder.query({
            query: ({ clientType, clientId, resourceId }) => ({
                url: `/${clientType}/report/${clientId}/${resourceId}`
            }),
            providesTags: ["ReportResourceDetail"],
            transformResponse: (response) => response?.data,
        }),
    })
})

export const {
    useAttachDocumentMutation,
    usePublishDocumentMutation,
    useUpdateAppointmentCountMutation,
    useGetReportResourceDetailQuery,
} = attachmentApi;